<template lang="pug" src="./privacy-policy.pug"></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'Privacy Policy',
  computed: {
    props () {
      return this.$store.state.pages['privacy-policy']
    }
  },
  components: {
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// privacy-policy.vue?4f95f0a7